import React from 'react';
import Loading from './Loading';

const ContentLoading = () => (
		<Loading type="page" />
);

export default ContentLoading;
